import { IOptionsDropdowns } from "shared";

export const fieldFormUpdateUsers = (
  optionsDropdowns: IOptionsDropdowns,
): IFieldForm[] => {
  return [
    {
      id: "itemformproviderCode",
      name: "organizationCode",
      type: "string",
      label: "Ingrese código del prestador",
      placeholder: "Código del prestador",
      required: true,
      maxLength: 20,
    },
    {
      id: "itemproviderNit",
      name: "employerIdNumber",
      type: "text",
      label: "Ingrese NIT del proveedor",
      placeholder: "NIT",
      required: true,
      maxLength: 20,
    },
    {
      id: "itemformtype",
      name: "type",
      type: "select",
      label: "Ingrese Naturaleza del prestador",
      placeholder: "Naturaleza del prestador",
      required: true,
      maxLength: 50,
      options: optionsDropdowns.typeHealthProvider,
    },
    {
      id: "itemformproviderName",
      name: "givenName",
      type: "text",
      label: "Ingrese nombre del prestador",
      placeholder: "Nombre del prestador",
      required: true,
      maxLength: 50,
    },
    {
      id: "itemformAcreedor",
      name: "acreedor",
      type: "text",
      label: "Ingrese Acreedor",
      placeholder: "Acreedor",
      required: true,
      maxLength: 20,
    },
    {
      id: "itemformDeparment",
      name: "region",
      type: "select",
      label: "Ingrese departamento",
      placeholder: "Departamento",
      required: true,
      options: optionsDropdowns.departments,
    },
    {
      id: "itemformProvince",
      name: "locality",
      type: "select",
      label: "Ingrese Ciudad",
      placeholder: "Ciudad",
      required: true,
      options: optionsDropdowns.cities,
    },
    {
      id: "itemformAddress",
      name: "streetAddress",
      type: "text",
      label: "Ingrese dirección",
      placeholder: "Dirección de residencia",
      required: true,
      maxLength: 150,
    },
    {
      id: "itemformEmail1",
      name: "email",
      type: "email",
      label: "Ingrese correo",
      placeholder: "Correo Electrónico",
      required: true,
      maxLength: 255,
    },
    {
      id: "itemformEmail2",
      name: "email2",
      type: "email",
      label: "Ingrese correo alterno",
      placeholder: "Correo Electrónico alterno",
      required: false,
      maxLength: 255,
    },
    {
      id: "itemformTel1",
      name: "phoneNumberOne",
      type: "textNumber",
      label: "Ingrese teléfono",
      placeholder: "",
      required: true,
      maxLength: 10,
    },
    {
      id: "itemformTel2",
      name: "phoneNumberTwo",
      type: "textNumber",
      label: "Ingrese teléfono alterno",
      placeholder: "",
      required: false,
      maxLength: 10,
    },
    {
      id: "itemformcontact1",
      name: "contactPersonOne",
      type: "text",
      label: "Ingrese Contacto 1",
      placeholder: "Contacto 1",
      required: true,
      maxLength: 50,
    },
    {
      id: "itemformcontact2",
      name: "contactPersonTwo",
      type: "text",
      label: "Ingrese Contacto 2",
      placeholder: "Contacto 2",
      required: false,
      maxLength: 50,
    },
    {
      id: "itemformcargoContacto1",
      name: "contactPersonOccupationOne",
      type: "text",
      label: "Ingrese Cargo Contacto 1",
      placeholder: "Cargo Contacto 1",
      required: true,
      maxLength: 50,
    },
    {
      id: "itemformcargoContacto2",
      name: "contactPersonOccupationTwo",
      type: "text",
      label: "Ingrese Cargo Contacto 2",
      placeholder: "Cargo Contacto 2",
      required: false,
      maxLength: 50,
    },
  ];
};

type IFieldForm = {
  id: string;
  name: string;
  type: string;
  label: string;
  placeholder: string;
  maxLength?: number;
  options?: any[];
  required: boolean;
};
